<mat-toolbar color="primary">
  <img src="/public/images/logo-tt-white.svg" width="35px" style="margin-right:6px"/>
  <a class="logo me-auto" href="/">{{ title }}</a>
  <app-language-selector class="language-selector" />
</mat-toolbar>

<div class="site-wrapper center-center">
  <router-outlet />
  <footer>
      &copy;{{ currentYear }}&nbsp;
      <a href="https://www.interpulse.nl/" target="_blank"> Interpulse Automatisering B.V. </a>
  </footer>
</div>
